// extracted by mini-css-extract-plugin
module.exports = {"rootElStyle":"PageStyle-module__rootElStyle___20eOi"};